<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Specs</b>
    </sui-card-content>
    <sui-card-content>
      <sui-table definition unstackable size="small" compact="very" basic="very">
        <sui-table-body>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">
              <i class="memory grey fitted icon"  />
            </sui-table-cell>
            <sui-table-cell>
              <b v-show="instanceData.memory" title="Instance RAM">{{instanceData.memory}} GB</b>
              <b v-show="!instanceData.memory">Unknown</b>
            </sui-table-cell>
          </sui-table-row>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">
              <i class="microchip grey fitted icon" />
            </sui-table-cell>
            <sui-table-cell style="position: relative;">
              <b v-show="instanceData.cores" title="Instance CPU">{{instanceData.cores}} vCPU</b>
              <b v-show="!instanceData.cores">Unknown</b>
              <i class="lock disabled icon" />
            </sui-table-cell>
          </sui-table-row>
          <sui-table-row title="Disk">
            <sui-table-cell collapsing text-align="center">
              <i class="disk grey fitted icon" />
            </sui-table-cell>
            <sui-table-cell style="position: relative;">
              <div v-show="!storageSize"><b>Unknown</b></div>
              <div v-show="storageSize" title="Storage size">
                <b>
                  <span title="Instance disk">{{storageSize}}</span>
                  <span title="Extra storage" v-show="host.extraStorage">&nbsp;+&nbsp;{{host.extraStorage}}</span>
                  GB {{host.storageType}}
                </b>
              </div>
              <i class="disabled icon" :class="resizedDisk ? 'unlock' : 'lock'" />
            </sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </sui-table>
    </sui-card-content>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="isResizeDisabled" @click="$modals.updateHost.open(host)" data-goal="HOST_PAGE_RESIZE">Resize</sui-button>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'HostSpecsCard',
    props: {
      host: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById']),
      actions() {
        return this.actionsById[this.host.id]
      },
      isCreated() {
        return this.host._isCreated
      },
      inProgress() {
        return this.host._inProgress
      },
      instanceData() {
        return this.host._instanceData
      },
      storageSize() {
        return this.host.storageSize || this.instanceData.storageSize
      },
      resizedDisk() {
        return this.host.storageSize !== this.instanceData.storageSize
      },
      isResizeDisabled() {
        return this.host.isCustom || this.inProgress || !this.isCreated || !this.actions.hostUpdate
      },
    },
  }
</script>

<style scoped>
  .content.content:nth-child(2) { padding: 0!important; justify-content: flex-start; }
  .table { margin: 0!important; height: 100%; }
  .center { padding: .4em .6em!important; height: 33.3333333333%; }
  .lock, .unlock { position: absolute; right: 5%; top: 0; transform: translate(0, -50%); }
</style>
